// Helper function to hide the loading spinner with fade animation
export function hideLoadingSpinner() {
  const spinner = document.getElementById('loadingSpinner')
  if (spinner) {
    spinner.classList.add('opacity-0')
    spinner.classList.add('transition-opacity')
    spinner.classList.add('duration-300')
    setTimeout(() => {
      spinner.style.display = 'none'
    }, 300)
  }
}